document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".bundle-quantity").forEach(function (el) {
    el.querySelector(".bundle-quantity-increment").addEventListener(
      "click",
      function () {
        var currentValue =
          parseInt(el.querySelector(".bundle-quantity-input").value) || 0; // Default to 0 if parsing fails
        el.querySelector(".bundle-quantity-input").value = currentValue + 1;
        updateQuantity(currentValue + 1, el.getAttribute("data-product-id"));
      }
    );

    el.querySelector(".bundle-quantity-decrement").addEventListener(
      "click",
      function () {
        var currentValue =
          parseInt(el.querySelector(".bundle-quantity-input").value) || 0; // Default to 0 if parsing fails
        if (currentValue > 1) {
          el.querySelector(".bundle-quantity-input").value = currentValue - 1;
          updateQuantity(currentValue - 1, el.getAttribute("data-product-id"));
        }
      }
    );
  });

  // document.querySelectorAll(".color-color-showall").forEach(function (el) {
  //   // add click event listener
  //   console.log("Adding click event listener to color-color-showal");
  //   el.addEventListener("click", function () {
  //     console.log('Clicked on "Show all"');
  //     const sliderQuery = `#bundle-slideout-combinations`;
  //     const slider = $(sliderQuery);
  //     const inner = $(`${sliderQuery} > .slideout--inner`);

  //     slider.removeClass("fade-in");
  //     inner.removeClass("open-inner");
  //     inner.one("transitionend", function () {
  //       slider.removeClass("open");
  //     });
  //   });
  // });

  document.querySelectorAll("#bundle-variant-item").forEach(function (el) {
    function closeSlider(id) {
      const sliderQuery = `#bundle-slideout-${id}`;
      const slider = $(sliderQuery);
      const inner = $(`${sliderQuery} > .slideout--inner`);

      slider.removeClass("fade-in");
      inner.removeClass("open-inner");
      inner.one("transitionend", function () {
        slider.removeClass("open");
      });
    }
    el.addEventListener("click", function () {
      const variantTitle = el.getAttribute("data-variant-title");
      const variantImage = el.getAttribute("data-variant-image");
      const variantId = el.getAttribute("data-variant-id");
      const productId = el
        .closest(".bundle-slideout")
        .getAttribute("data-product-id");
      console.log("Product ID: " + variantId);

      closeSlider(productId);

      // get same .bundle-product-listing with same data-product-id
      const productListing = document.querySelector(
        ".bundle-product-listing[data-product-id='" + productId + "']"
      );

      // get img child from productListing and replace src with variantImage
      productListing.querySelector("img").src = variantImage;
      // set data-variant-id of productListing to variantTitle
      productListing.setAttribute("data-variant-id", variantId);
    });
  });
  document
    .getElementById("bundle-add-to-cart")
    .addEventListener("click", function () {
      const variantIds = [];

      const bundleListings = document.querySelectorAll(
        ".bundle-product-listing"
      );
      const combinations = document.querySelectorAll(".color-combi-chooser");

      if (bundleListings.length > 0) {
        // Listings
        bundleListings.forEach(function (el) {
          const variantId =
            el.getAttribute("data-variant-id") ||
            el.getAttribute("data-product-id");
          const quantity = parseInt(el.getAttribute("data-quantity")) || 1;
          const price = parseFloat(el.getAttribute("data-price")) || 0;
          variantIds.push({ id: variantId, quantity, price: price });
        });
      } else if (combinations.length > 0) {
        // Combinations
        const combi = Array.from(combinations).find(
          (el) => el.dataset.selected === "true"
        );
        const index = combi.dataset.index;

        const allCombinations = JSON.parse(
          document.querySelector("#color-combi-data").textContent
        );
        const data = allCombinations[index];

        console.log(data);

        const variants = data.varianter;
        const quantities = combi.dataset.quantity.split(",");

        variants.forEach(function (variant, i) {
          variantIds.push({
            id: variant.id,
            quantity: parseInt(quantities[i]),
            image: data.billede,
            price: variant.price,
          });
        });
      }

      const bundleVariantImage = document.getElementById("bundle-image").value;
      const bundleTitle = document.getElementById("bundle-title").value;
      const bundleHandle = document.getElementById("bundle-handle").value;
      const bundleVariantId = document.querySelector("[name=id]").value;
      const bundlePdf = document.getElementById("bundle-pdf")?.value;
      // find input witgh name "Størrelse" and get value
      let checkedInput = document.querySelector(
        'input[name="Størrelse"]:checked'
      );

      const data = variantIds.map((variant) => ({
        id: variant.id,
        quantity: variant.quantity,
        properties: {
          _bundleItemImage: variant.image ?? bundleVariantImage,
          _bundleTitle: bundleTitle,
          _bundleVariantId: bundleVariantId,
          _bundlePdf: bundlePdf ?? "",
          _bundleHandle: bundleHandle,
          _bundleQuantity: variant.quantity,
          _bundlePrice: variant.quantity * variant.price,
          _bundleDiscount: 0,
          Størrelse: checkedInput?.value || "",
        },
      }));

      addItemToCart(data);
    });

  function addItemToCart(dataArray = []) {
    if (dataArray.length === 0) return;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: dataArray }),
    })
      .then(function (response) {
        if (response.ok) {
          window.location.reload();
        } else return response.text();
      })
      .then(function (text) {
        if (text) {
          let parsedMessage = JSON.parse(text);
          throw new Error(parsedMessage.description);
        }
      })
      .catch(function (error) {});
  }

  function updateQuantity(quantity, id) {
    const productListing = document.querySelector(
      `.bundle-product-listing[data-product-id='${id}']`
    );
    productListing.querySelector(".quantity-span").textContent = quantity + "x";
    productListing.setAttribute("data-quantity", quantity);
    /* loop all .bundle-product-listing and get total price */
    let totalPrice = 0;
    document.querySelectorAll(".bundle-product-listing").forEach(function (el) {
      const price = parseFloat(el.getAttribute("data-price")) || 0;
      const quantity = parseInt(el.getAttribute("data-quantity")) || 1;
      totalPrice += price * quantity;
    });
    document.getElementById("bundle-variant-price").textContent =
      totalPrice.toFixed(2).replace(".", ",") + " DKK";
  }

  const combinations = document.querySelectorAll(".color-combi-chooser");

  function updatePrice(index) {
    const combi = Array.from(combinations).find(
      (el) => parseInt(el.dataset.index) === index
    );
    const quantities = combi.dataset.quantity.split(",");

    const data = JSON.parse(
      document.querySelector("#color-combi-data").textContent
    );
    console.log("data: ", data, data[index]);
    const variant = data[index];

    const price = variant.varianter.reduce(
      (acc, el, i) => acc + (el.price / 100) * parseInt(quantities[i]),
      0
    );
    const Cprice = variant.varianter.reduce(
      (acc, el, i) =>
        acc +
        (el.compare_at_price ? el.compare_at_price / 100 : 0) *
          parseInt(quantities[i]),
      0
    );

    const salePriceElement = document.querySelector(
      "div.price__sale .price-item.price-item--sale"
    );
    if (salePriceElement) {
      salePriceElement.textContent = price + " DKK";
    }
    const regularPriceElement = document.querySelector(
      "div.price__sale .price-item--regular"
    );
    if (regularPriceElement) {
      regularPriceElement.textContent = Cprice + " DKK";
    }
  }

  function selectCombination(index) {
    document.querySelector(".product-form__submit").disabled = false;
    combinations.forEach((el) => {
      el.dataset.selected =
        parseInt(el.dataset.index) === index ? "true" : "false";
    });
    const data = JSON.parse(
      document.querySelector("#color-combi-data").textContent
    );
    const variant = data[index];
    updatePrice(index);
    const media = document.querySelector(".product__media > img");
    const newSrc = `https:${variant.billede}`;
    media.src = newSrc;
    media.srcset = newSrc;
  }

  combinations.forEach((combi) =>
    combi.addEventListener("click", () =>
      selectCombination(parseInt(combi.dataset.index))
    )
  );

  updatePrice(0);
});
